import { render } from "./SelectorGenderCategories.vue?vue&type=template&id=0d36afae&scoped=true"
import script from "./SelectorGenderCategories.vue?vue&type=script&lang=js"
export * from "./SelectorGenderCategories.vue?vue&type=script&lang=js"

import "./SelectorGenderCategories.vue?vue&type=style&index=0&id=0d36afae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d36afae"]])

export default __exports__